import api from '../../axios';

// AD-2699: saved reports for the Reports page.
export const getSavedReports = async () => (await api.get('/reports/saved')).data;

export const saveReport = async (report) => (await api.post('/reports/saved', report)).data;

export const recordReportRun = async (id) => (await api.post(`/reports/saved/${id}/run`)).data;

// Maria, 15 October 2026: the person who saved a report, or a School Admin, can delete it.
export const deleteSavedReport = async (id) => (await api.delete(`/reports/saved/${id}`)).data;
